var React = require('react');

function SkiJump (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm110.7 94.2a24 24 0 0 0-47.4 8c3.3 19.3-6 38.9-22.1 48.1L13 466.7A24 24 0 0 0 24.1 512a24.14 24.14 0 0 0 11-2.7l429.2-220.9a95.42 95.42 0 0 0 46.4-98.2z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M113.7 414.8a31.85 31.85 0 0 1-7.3-35c60.4-146.9 56.8-138.9 60.2-143.3l58.9-76.5H128a32 32 0 0 1 0-64h184a40 40 0 0 1 28.3 68.3L218.9 274.8l-44.9 109z","className":"fa-primary","key":2})]);
}

SkiJump.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = SkiJump;

SkiJump.default = SkiJump;
